export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/gdo.72afbbc4.svg";